import React, { Component } from "react";
import { connect } from "react-redux";
import CustomSelect from "../../components/common/select/Select";
import DurationMiddleware from "../../store/prat_middleware/gt/durationMiddleware";
import { openDB} from 'idb';
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import "./style/duration.scss";
import IsDuration from './validation/durationSection'

let start_dated;
let durationData=[];
let isSaveDraft=false;
let isDate=false;     // eslint-disable-line
let end_dated;
class Duration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedStartWeek:'',
      selectedEndWeek:'',
      checked:  true,
      switch: true,
      startDate:'',
      endDate:'',
      sync:false,
      picker_startDate:'',
      picker_endDate:'',
      isIndexedDbDate:false,
      localStartdate:'',
      localEnddate:'',
      localStartWeek:'',
      localEndWeek:'',
      durationData_state:undefined,
      propsData:undefined,
      switch_waiting_state:false,
      years:undefined,
      selectedYear:undefined,
      validation_for_dateStart:undefined,
      state_for_filter:undefined,
      startWeekForPlaceholder:'',
      endWeekForPlaceholder:''

    };
  }
  componentDidMount() {

    let currentDate = new Date()
    let currentMonth = currentDate.getMonth();
    let currentYear=currentDate.getFullYear()
    let nextyear = currentYear+1
    let years = []

    years.push({value:'current-123-9001',Name:currentYear}
    )
    if(currentMonth > 9){
      years.push({value:'current-123-9001',Name:nextyear}
      )
    }

    const {
      get_startWeek,
      get_endWeek,
      startWeek,
      endWeek,
    } = this.props;   
    
    setTimeout(() => {
      this.setState({switch_waiting_state:true})
      get_startWeek(this.state.selectedYear, this.props.is_extended?.IsExtended ? this.state.selectedStartWeek : '');
      get_endWeek(this.state.selectedYear,this.props.is_extended?.IsExtended ? this.state.selectedStartWeek : '');
  },1000)
this.firstTimeData(startWeek,endWeek)

this.setState({checked:false,years:years,selectedYear:currentYear})  

}

  firstTimeData(startWeek,endWeek){
    this.forceUpdate()
    const getData = async  (startWeek,endWeek) => {
    if (!("indexedDB" in window)) {
        console.warn("IndexedDB not supported");
        return;
      }
      const dbName = "gt_form";
      const storeName = "product_store";
      const version = 1; //versions start at 1

        const db = await openDB(dbName, version, {
        
      });
      let result =   await db
        .transaction(storeName)
        .objectStore(storeName)
        .get("duration_detail");
        durationData=result ? result.value : []
        if(durationData.length===0){
          start_dated=undefined
          end_dated=undefined
          isDate=false
          this.setState({switch:true,startDate:'',endDate:''})
        }

        durationData=durationData? durationData[0]?durationData[0]:durationData:[]
        if(durationData.length!==0){
          isSaveDraft=true

          let filtered, endweekFiltered;

          if(startWeek && endWeek){
             filtered = startWeek&&startWeek.filter(e => {return e.substr(0,7) ===`Week ${durationData?.WeekStart}`})
             endweekFiltered = endWeek&&endWeek.filter(e => {return e.substr(0,7) ===`Week ${durationData?.WeekEnd}`})
            let saveStartWeek = durationData?.WeekStart ? `Week ${durationData?.WeekStart} - ${durationData?.DateStart}` : '';
            let saveEndWeek = durationData?.WeekEnd ? `Week ${durationData?.WeekEnd} - ${durationData?.DateEnd}` : '';
            this.setState({
              startWeekForPlaceholder: saveStartWeek,
              endWeekForPlaceholder: saveEndWeek
            })

          }

          if(durationData?.WeekStart ){
          let test = filtered?'true':'false'    // eslint-disable-line
            this.setState({selectedStartWeek: !filtered ? durationData?.WeekStart : filtered[0]?.substr(5,2),
              localStartWeek: filtered ? filtered[0] : durationData?.localStartWeek },()=>{
              })
          }
          if(durationData?.WeekEnd){
            this.setState({selectedEndWeek: !endweekFiltered ? durationData?.WeekEnd : endweekFiltered[0]?.substr(5,2),
              // state_for_filter: !endweekFiltered ? durationData?.WeekEnd : endweekFiltered[0]?.substr(5,2),
                localEndWeek: endweekFiltered ? endweekFiltered[0] : durationData?.localEndWeek },()=>{
                })
          }
          if(durationData?.DateStart){
             let filteredDate =  this.props.is_extended?.IsExtended === true ? 
                                 durationData?.DateEnd :  durationData?.DateStart;
             let filteredMonth = filteredDate.substr(3,3);
             let filteredDay = filteredDate.substr(0,2);
             let filteredYear = filteredDate.substr(7,4);
             let finalMonth;
             let extractDate;
             function getMonthFromString(filteredMonth){
              finalMonth = new Date(Date.parse(filteredMonth + '1, `${this.state.selectedYear}`')).getMonth();// eslint-disable-line
               extractDate = new Date(filteredYear,finalMonth,filteredDay)
        
           }
           getMonthFromString(filteredMonth)
            this.setState({startDate:durationData?.DateStart,localStartdate:durationData?.localStartdate,validation_for_dateStart:extractDate});
          }
          if(durationData?.DateEnd){
            this.setState({endDate:durationData?.DateEnd,isIndexedDbDate:true,localEnddate:durationData?.localEnddate})
          }
            if(durationData?.IsDate){
            this.setState({checked:!durationData?.IsDate,switch:!durationData?.IsDate,isIndexedDbDate:durationData?.IsDate})
            isDate=!durationData?.isDate
          }
          if(durationData?.year){
            this.setState({selectedYear:durationData?.year})
          }
          isSaveDraft=true
        }
        else{
          this.setState({
            endDate:'',
            startDate:'',
            selectedStartWeek:'',
            selectedEndWeek:''
          })
          isSaveDraft=true
        }
    }
    
          getData(startWeek,endWeek) ;          
        isSaveDraft=true
  }


  toggleChecked = () => {
    this.setState({ checked: !this.state.checked });
  };

  saveDurationData(data,flag){
    const saveData = async  (data,flag) => {
      if (!("indexedDB" in window)) {
          console.warn("IndexedDB not supported");
          return;
        }
  
        const dbName = "gt_form";
        const storeName = "product_store";
        const version = 1; //versions start at 1
  
         const db = await openDB(dbName, version, {
          upgrade(db, oldVersion, newVersion, transaction) {
            const store = db.createObjectStore(storeName);      // eslint-disable-line
          }
        });
        const tx = await db.transaction(storeName, "readwrite");
        const store = await tx.objectStore(storeName);

              const value = await store.put({"key":"duration_123","value": data },"duration_detail");       // eslint-disable-line
              const isSave = await store.put({"key":"draft_123","value":flag},"is_draft_saved")             // eslint-disable-line

          await tx.dones;                
    
          let resp; let txs;let obj;  
          resp  =   await db
          txs  = await resp.transaction(storeName)
          obj= await txs.objectStore(storeName)
          let dataRes = await obj.get('duration_detail');
          let draft = await obj.get('is_draft_saved');
  
  
          durationData=dataRes ? dataRes.value : []
          draft=draft ? draft.value : void 0
          this.props.call_back( this.props.draft_state===true?true:isSaveDraft===true?false: draft)

        }
        if(isSaveDraft===false){
          saveData(data,flag)
        }
        else{
          isSaveDraft=false
        }
        // saveData(data,flag)
  }
  
  getDurationData(){
      const getData = async  () => {
        if (!("indexedDB" in window)) {
            console.warn("IndexedDB not supported");
            return;
          }
          const dbName = "gt_form";
          const storeName = "product_store";
          const version = 1; //versions start at 1
    
           const db = await openDB(dbName, version, {
            
          });
            let result =   await db
                    .transaction(storeName)
                    .objectStore(storeName)
                    .get("duration_detail");
        
                   durationData=result ? result.value : []
    
          }
    
          getData() ;          
  }
  componentWillUnmount() {
    this.setState = (state,callback)=>{
      return;
  };
  }
//WARNING! To be deprecated in React v17. Use componentDidMount instead.
UNSAFE_componentWillMount() {
  durationData=durationData[0]?durationData[0]:durationData
     if(durationData.length!==0){
      isSaveDraft=true
      if(durationData.WeekStart){
        this.setState({selectedStartWeek:durationData.WeekStart})
      }
      if(durationData.WeekEnd){
        this.setState({selectedEndWeek:durationData.WeekEnd})
      }
      if(durationData.DateStart){
        this.setState({startDate:durationData.DateStart})
        // start_dated=this.state.startDate
      }
      if(durationData.DateEnd){
        this.setState({endDate:durationData.DateEnd})
      }
        if(durationData.IsDate){
        this.setState({checked:!durationData.IsDate,switch:!durationData.IsDate,isIndexedDbDate:durationData.IsDate})
        isDate=!durationData.isDate
      }
      // if(durationData.year){
      //   this.setState({selectedYear:durationData.year},
      //     ()=>{
      //     })
      // }
    isSaveDraft=true
    }

    if(durationData.length===0){
      start_dated=undefined
      end_dated=undefined
      isDate=false     
      this.setState({switch:true,startDate:'',endDate:''})
    }

}

componentDidUpdate(prevProps, prevState) {
  if((prevProps.startWeek!==this.props.startWeek)||(prevProps.endWeek!==this.props.endWeek)  ){
    this.firstTimeData(this.props.startWeek,this.props.endWeek)
   }

  //  if(this.state.selectedYear !== prevState.selectedYear){
  //  }
   
   const {selectedEndWeek,selectedStartWeek,startDate,endDate,localStartdate,localStartWeek,localEnddate,
          localEndWeek } = this.state;
  
      if((this.state.selectedStartWeek!==prevState.selectedStartWeek) || (this.state.selectedEndWeek!==prevState.selectedEndWeek)
         ||(this.state.startDate!==prevState.startDate) || (this.state.endDate!==prevState.endDate) || 
         (this.state.localStartWeek!==prevState.localStartWeek) || (this.state.localEndWeek !==prevState.localEndWeek) ||
         (this.state.switch !==prevState.switch) || (this.state.selectedYear !== prevState.selectedYear)){
       
        isSaveDraft=false
          if(isSaveDraft === false){
             start_dated = startDate && startDate.toString() 
              start_dated = start_dated?.substr(8,2) + " " + start_dated?.substr(4,3)+" " +  start_dated?.substr(11,4);
               end_dated = endDate?.toString()
              end_dated = end_dated?.substr(8,2) + " " + end_dated?.substr(4,3)+" " +  end_dated?.substr(11,4)
              let statedata = [{
            year:this.state.selectedYear,
            IsDate:!this.state.switch,
            WeekStart: this.state.switch === true?selectedStartWeek :null,
            WeekEnd:this.state.switch === true? selectedEndWeek : null,
            DateStart: this.state.switch === true? localStartWeek?.substr(10,) :
             start_dated.substr(start_dated.length-2)!=="  "?start_dated : startDate,
            DateEnd:this.state.switch === true?  localEndWeek?.substr(10,) :
            end_dated.substr(end_dated.length-2)!=="  "?end_dated : endDate,
            localStartdate,
            localEnddate,
            localStartWeek,
            localEndWeek,
            }];    
            this.saveDurationData( !this.state.localStartWeek && durationData.WeekStart && !this.state.localEndWeek && durationData.WeekEnd? durationData : statedata,true)
        this.forceUpdate()

          }
          else{
            isSaveDraft=false
          }
        }
        else{
          return true
        }

   
}

handleYearChange = (year) =>{
  if(this.state.selectedYear == year.value){    // eslint-disable-line
    return
  }
  this.setState({
    selectedYear:year.value,
    picker_startDate:'',
    startDate:'',
    localStartdate:'',
    selectedStartWeek:'',
    localStartWeek:'',
    endDate:'',
    localEnddate:'',
    selectedEndWeek:'',
    localEndWeek:''
  },
  ()=>{
    this.props.get_endWeek(this.state.selectedYear)
    this.props.get_startWeek(this.state.selectedYear)
    IsDuration.isduration('year',this.state,this.props,this.state.selectedYear)
    IsDuration.isduration('week_start',this.state,this.props)
    IsDuration.isduration('date_start',this.state,this.props,this.state.start_dated)
    IsDuration.isduration('week_end',this.state,this.props)
    IsDuration.isduration('date_end',this.state,this.props,this.state.end_dated)
  })
}

  render() {
    const {
     selectedStartWeek,startDate,endDate,localEndWeek,localEnddate,
     localStartdate,localStartWeek,years,validation_for_dateStart
    } = this.state;
    const { startWeek,endWeek } = this.props;

    let filterd = endWeek?.findIndex((i,e) => { return i?.substr(0,7) === `Week ${selectedStartWeek}`  })
    let filterd_is_extend =  this.props.old_preOpso?.end_week && endWeek?.findIndex((i,e) => { return i?.substr(0,7) === this.props.old_preOpso?.end_week?.substr(0,7)  })
    
    let is_final= endWeek?endWeek.slice(filterd,) : void 0
    let is_extended= endWeek?endWeek.slice(filterd_is_extend,) : void 0
    let final = this.props.is_extended?.IsExtended === true ? is_extended : is_final
    // let change_month =selectedStartWeek?.substr(13,3)
    this.props.counter!==4  ? this.saveDurationData(durationData,this.props.draft_state) : void 0;
    this.props.counter === 4  || durationData.length!==0 ? this.getDurationData() : void 0
    return (
      <>
        <div>
          <div className="product_detail">
            <p>Duration Detail</p>
          </div>
          <div className="label_id">
            <label for="prom">Year <span className='mandatory_fields' >*</span> </label>
          </div>

          <div style={{ width: "30.5vw" }}>
            <CustomSelect.MySelect
              placeholder={"Year"}
              isDisabled={this.props.is_extended?.IsExtended === true ? true : false}
              options={years?.map(
                item => ({
                  value: item.Name,
                  label: item.Name
                })
              )}
                onChange={this.handleYearChange}
                value={years && years.filter(item=>{
                  return item.Name == this.state.selectedYear     // eslint-disable-line
                })
              .map(item => {
                return {
                  value: item.Name,
                  label: item.Name
                };
              })
            }
            />
          </div>
          <div className="label_id">
            <label for="prom">{/* Promotion Type */}</label>
          </div>

          <div className="date_toggle_main">
            <div>
              <p>Date</p>
            </div>
            <div style={this.props.currentForm === 'mt' ? {} : {pointerEvents:'none'}}>
              <label className="__switch">
                {this.state.switch_waiting_state!==true? undefined : this.state.checked === false && this.state.switch=== false  ?
                 (
                  <input
                    type="checkbox"
                    // checked
                    value={this.state.switch}
                    onClick={() => {
                      this.setState({
                        switch: !this.state.switch,
                        checked: false
                      });
                    }}
                  />
                ):
                (
                   <input
                    type="checkbox"
                    checked
                    value={this.state.switch}
                    onClick={e => {
                      this.setState({
                        switch: !this.state.switch,
                        checked: false
                      });
                    }}
                    
                  />  
                                
                )
                }
                <span className="__slider __round" style={this.props.currentForm === 'mt' ? {} : {backgroundColor:'#f2f2f2'}}></span>
              </label>
            </div>
            <div>
              <p>Week</p>
            </div>
          </div>

          <div className="data_toggle_lower">
            <div className="from_to">
              <div className="label_id">
                <label for="">From <span className='mandatory_fields' >*</span> </label>
              </div>
              <div style={{ width: "15.5vw" }}>
                {this.state.switch===true?
                <CustomSelect.MySelect
                  isDisabled={this.props.is_extended?.IsExtended === true ? true : false}
                  placeholder={this.state.switch === true ? !startWeek? "Loading..." : startWeek[0].substr(0,7) +" "+startWeek[0].substr(17,4) : "days"}
                  options={ this.state.switch === true?
                    startWeek
                    ? startWeek.map(item => ({
                      value:12-34-56,
                      label:item
                    }))
                  :void 0 :void 0
                  }
                  value={
                    startWeek
                    ? startWeek
                        .filter(item => {
                            return !localStartWeek  ?void 0 : localStartWeek.substr(0,7)  === item.substr(0,7)
                        })
                        .map(item => {
                            return {
                            value: 12-34-56,
                            label: item
                            };
                        })
                    : null    
                  }
                  onChange={(e) => {this.setState({selectedStartWeek:e.label.substr(5,2),localStartWeek:e.label},()=>{
                    IsDuration.isduration('week_start',this.state,this.props)
                  });  } }
                />
                :
               <div  className='date_picker' style={
                this.props.is_extended?.IsExtended === true ?{backgroundColor:'#f3f3f3',cursor:'notAllowed'}:void 0} >
                 {!start_dated || start_dated?.substr(start_dated.length-2)=== "  " && !startDate?    // eslint-disable-line
                 <p className='is_notPara' > Starting Date </p>:
                 <p style={
                  this.props.is_extended?.IsExtended === true ?{backgroundColor:'#f3f3f3',cursor:'not-allowed'}:void 0  
                } className='is_para' >{ typeof startDate!=="string" ? start_dated : startDate}</p>
                }
                {this.props.is_extended?.IsExtended === true ?
                <DatePicker
                
                disabled  
                placeholderText="Select Date From"
                selected={localStartdate }
                onChange={date => this.setState({startDate:date,picker_startDate:date,localStartdate:date},()=>{
                  setTimeout(() => {
                    IsDuration.isduration('date_start',this.state,this.props,start_dated)
                  }, 100);
                })
              }
                selectsStart
                minDate={!startDate?new Date():validation_for_dateStart}
                withPortal
                showMonthDropdown
                useShortMonthInDropdown
                showWeekNumbers
                className={start_dated!=="  "? 'isDate': 'hide_picker'}
              
               />:
               <DatePicker
                  
                placeholderText="Select Date From"
                selected={localStartdate }
                onChange={date => this.setState({startDate:date,picker_startDate:date,localStartdate:date},()=>{
                  setTimeout(() => {
                    IsDuration.isduration('date_start',this.state,this.props,start_dated)
                  }, 100);
                })
              }
                selectsStart
                minDate={!startDate?new Date():validation_for_dateStart}
                withPortal
                showMonthDropdown
                useShortMonthInDropdown
                showWeekNumbers
                className={start_dated!=="  "? 'isDate': 'hide_picker'}
              
               />}
              </div>

            
              }
              </div>
            </div>

            <div className="from_to">
              <div className="label_id">
                <label for="">To <span className='mandatory_fields' >*</span> </label>
              </div>
              <div style={{ width: "15.5vw" }}>
                {this.state.switch===true?
                <CustomSelect.MySelect
                placeholder={this.state.switch === true ? (!endWeek || endWeek?.length===0)? "Loading..." : endWeek[endWeek.length-1].substr(0,7) + " " + endWeek[endWeek.length-1].substr(17,4) : "days"}
                options={ this.state.switch === true?
                    final
                    ? final.map(item => ({
                      value:31-90-65,
                      label:item
                    }))
                  :void 0 :void 0
                  }
                  onChange={(e) => {this.setState({selectedEndWeek:e.label.substr(5,2),localEndWeek:e.label},()=> {
                    IsDuration.isduration('week_end',this.state,this.props)
                  }) }}
                  value={
                    endWeek
                    ? endWeek
                        .filter(item => {
                            return !localEndWeek?void 0 : localEndWeek.substr(0,7) === item.substr(0,7)
                        })
                        .map(item => {
                            return {
                            value: 31-90-65,
                            label: item
                            };
                        })
                    : null    
                  }
                />:
                 <div  className='date_picker' >
                 {!end_dated || end_dated?.substr(end_dated.length-2)==="  " && !endDate?   // eslint-disable-line
                 <p className='is_notPara' > Ending Date </p>:
                 <p className='is_para' >{ typeof endDate!=="string" ? end_dated : endDate}</p>
                }
                <DatePicker
                placeholderText="Select Date To"
                selected={localEnddate}
                onChange={date => this.setState({endDate:date,picker_endDate:date,localEnddate:date},()=> {
                  setTimeout(() => {
                    IsDuration.isduration('date_start',this.state,this.props,end_dated)
                  }, 100);            
                })
              }
                minDate={localStartdate ?  localStartdate :validation_for_dateStart  }
                selectsStart
                withPortal
                showMonthDropdown
                useShortMonthInDropdown
                showWeekNumbers
                className={ startDate &&!endDate ? "endHide_picker" : end_dated!=="  " || end_dated?.substr(end_dated.length-2)!=="  "?
                 'isDate': "hide_picker"}
              />
              </div>
              }
              </div>
            </div>           
          </div>
        </div>       
      </>
    );
  }
}

// redux

const mapStateToProps = state => {
  return {
    startWeek: state.DurationReducer.startWeek,
    endWeek: state.DurationReducer.endWeek,
    draftData: state.CreatePromotionReducer.draftData?.ActivityMetadata,
    is_extended: state.CreatePromotionReducer.draftData,
    old_preOpso: state.ApprovalReducer.old_preOpso,

    
  };
};

const mapDispatchToProps = dispatch => {
  return {
    get_startWeek: (year,week) => {
      return dispatch(DurationMiddleware.get_startWeek (year,week));
    },
    get_endWeek: (year,week) => {
      return dispatch(DurationMiddleware.get_endWeek(year,week) );
    },  
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Duration);
